(() => {
  if (customElements.get('pf-collection-disclosure')) return;
// Reuse the description's translated labels, with one local disclosure state.
class PfCollectionDisclosure extends HTMLElement {
  connectedCallback() {
    this.frame = requestAnimationFrame(() => this.enhance());
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.frame);
    cancelAnimationFrame(this.scrollFrame);
  }

  enhance() {
    if (this.dataset.pfReady) return;
    const embedded = this.querySelector('.pf-collection-description');
    const more = embedded?.querySelector('.pf-read-more');
    const less = embedded?.querySelector('.pf-show-less');
    const panel = embedded?.querySelector('.pf-collection-more');
    if (more && less && panel) {
      const toggle = embedded.querySelector('.pf-collection-toggle');
      const expanded = Boolean(toggle?.checked || panel.matches(':target'));
      const button = this.makeButton(more.textContent, less.textContent, panel.id);
      embedded.append(button);
      // Remove both old links/labels; never layer a second toggle over them.
      embedded.querySelectorAll('.pf-read-more, .pf-show-less, .pf-collection-toggle').forEach(node => node.remove());
      // Also remove a legacy outer clamp if an older section supplied one.
      this.querySelectorAll('.pf-ci__more, .pf-ci__toggle, .pf-cf__more, .pf-cf__toggle').forEach(node => node.remove());
      this.classList.remove('pf-ci--clamp', 'pf-cf--clamp');
      embedded.dataset.pfEnhanced = '';
      this.bindButton(button, expanded, open => {
        embedded.dataset.pfExpanded = String(open);
        panel.hidden = !open;
      });
    } else {
      const original = this.querySelector('.pf-ci__more, .pf-cf__more');
      const toggle = this.querySelector('.pf-ci__toggle, .pf-cf__toggle');
      const body = this.querySelector('.pf-ci__desc, .pf-cf__body');
      if (!original || !toggle || !body) return;
      let moreLabel = original.querySelector('[class$="__more-open"]').textContent.trim();
      let lessLabel = original.querySelector('[class$="__more-close"]').textContent.trim();
      // Reuse this collection's translation when footer settings still contain defaults.
      const intro = document.querySelector('.pf-ci');
      const translated = intro?.querySelector('.pf-collection-disclosure__toggle');
      if (moreLabel === window.PetifoI18n.common.read_more && lessLabel === window.PetifoI18n.common.read_less) {
        moreLabel = translated?.dataset.more || intro?.querySelector('.pf-read-more')?.textContent.trim() || moreLabel;
        lessLabel = translated?.dataset.less || intro?.querySelector('.pf-show-less')?.textContent.trim() || lessLabel;
      }
      const button = this.makeButton(moreLabel, lessLabel, body.id);
      original.replaceWith(button);
      toggle.hidden = true;
      toggle.tabIndex = -1;
      toggle.setAttribute('aria-hidden', 'true');
      this.bindButton(button, toggle.checked, open => { toggle.checked = open; });
      // Keep focused links readable even when a legacy fallback uses a height clamp.
      body.addEventListener('focusin', () => {
        if (!toggle.checked) button.click();
      });
    }
    this.dataset.pfReady = '';
  }

  makeButton(more, less, panelId) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'pf-collection-disclosure__toggle';
    button.dataset.more = more.trim();
    button.dataset.less = less.trim();
    button.setAttribute('aria-controls', panelId);
    return button;
  }

  bindButton(button, initial, update) {
    const render = open => {
      update(open);
      button.setAttribute('aria-expanded', String(open));
      button.textContent = open ? button.dataset.less : button.dataset.more;
    };
    render(initial);
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') !== 'true';
      cancelAnimationFrame(this.scrollFrame);
      render(open);
      // Let browser scroll anchoring settle, then keep the same control visible.
      // No navigation, hash mutation, network request or scroll animation.
      if (!open) {
        this.scrollFrame = requestAnimationFrame(() => {
          if (button.isConnected && button.getAttribute('aria-expanded') === 'false') {
            button.scrollIntoView({ block: 'nearest', behavior: 'instant' });
          }
        });
      }
    });
  }
}

if (!customElements.get('pf-collection-disclosure')) {
  customElements.define('pf-collection-disclosure', PfCollectionDisclosure);
}

})();
